"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

/**
 * @name OverflowContainer
 * @description Component which uses to prevent page scrolling
 * @param {Object} Props - OverflowContainer parameter object
 * @param {boolean} Props.shouldBlockScroll - A flag which indicates whether scroll blocking is needed
 * @param {JSX.Element} Props.children - A child element of container.
 * @returns {JSX.Element}
 * @memberof privacy-shared-react
 */
var OverflowContainer = function OverflowContainer(_ref) {
  var shouldBlockScroll = _ref.shouldBlockScroll,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, shouldBlockScroll && /*#__PURE__*/_react.default.createElement(_core.Global, {
    styles: {
      body: {
        overflow: 'hidden !important'
      }
    }
  }), children);
};

exports.OverflowContainer = OverflowContainer;